import { render, staticRenderFns } from "./wechat-login.vue?vue&type=template&id=6990d888&scoped=true&"
import script from "./wechat-login.vue?vue&type=script&lang=js&"
export * from "./wechat-login.vue?vue&type=script&lang=js&"
import style0 from "./wechat-login.vue?vue&type=style&index=0&id=6990d888&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990d888",
  null
  
)

export default component.exports